export function getLevel(levels, score) {
  const lvs = [...levels].sort((a, b) => b.score - a.score);
  const current = lvs.find((l) => score >= l.score);
  const next = lvs[lvs.indexOf(current) - 1];

  return { current, next };
}
